import React from "react";
import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { PageLayout } from "../../ui-components/PageLayout";
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid2";
import Typography from "@mui/material/Typography";
const CheckoutReturn = () => {
  const [status, setStatus] = useState<string>();
  const [customerEmail, setCustomerEmail] = useState();

  useEffect(() => {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const sessionId = urlParams.get("session_id");

    if (!sessionId) {
      setStatus("error");
      return;
    }
    setStatus("loading");
    fetch(`/session-status?session_id=${sessionId}`)
      .then((res) => res.json())
      .then((data) => {
        setStatus(data.status);
        setCustomerEmail(data.customer_email);
      })
      .catch((error) => {
        console.error("Error:", error);
        setStatus("error");
      });
  }, []);

  if (status === "open") {
    return <Navigate to="/payment/checkout" />;
  }
  const renderContent = () => {
    switch (status) {
      case "loading":
        return <p>Verifying your purchase...</p>;
      case "success":
        return (
          <p>
            We appreciate your business! A confirmation email will be sent to{" "}
            {customerEmail}.
          </p>
        );
      case "pending":
        return (
          <p>
            Your payment is being processed. We'll notify you when it's
            complete.
          </p>
        );
      case "error":
        return (
          <p>There was an issue with your payment. Please contact support.</p>
        );
      //open: The payment failed or was canceled. Remount Checkout so that your customer can try again.
      case "open":
        return <Navigate to="/payment/checkout" />;
      default:
        return <p>Checking payment status...</p>;
    }
  };

  return (
    <PageLayout>
      <Card sx={{ p: 3 }}>
        <Grid container spacing={3}>
          <Grid size={12}>
            <Typography variant="h4">Payment Confirmation</Typography>
          </Grid>

          <Grid size={12}>
            {/* size={{ xs: 6, md: 4 }} */}
            {renderContent()}
          </Grid>
        </Grid>
      </Card>
      {/* {status === "success" && (
        <section id="success">
          <p>
            We appreciate your business! A confirmation email will be sent to{" "}
            {customerEmail}. If you have any questions, please email{" "}
            <a href="mailto:orders@example.com">orders@example.com</a>.
          </p>
        </section>
      )}
      {status === "pending" && (
        <section id="pending">
          <p>
            Your payment is being processed. We'll notify you when it's
            complete.
          </p>
        </section>
      )}{" "}
      {status === "error" && (
        <section id="error">
          <p>There was an issue with your payment. Please contact support.</p>
        </section>
      )}
      {status === "" && (
        <section id="loading">
          <p>Verifying your purchase...</p>
        </section>
      )} */}
    </PageLayout>
  );

  // return null;
};

export default CheckoutReturn;
